import { connect } from "@formily/react";
import { Input } from "./Input";

// TODO implement a proper telephone validation, probably through libphonenumber-js
export const Telephone = connect((props) => {
  const enhancedProps = {
    ...props,
    inputMode: "tel",
  };

  return <Input {...enhancedProps} />;
});
